import axios from "axios";

// 创建一个axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: "",
  timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，比如添加token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["token"] = `${token}`;
    }
      // 设置 Content-Type
      if (config.method === 'post') {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
      }
    return config;
  },
  (error) => {
    // 处理请求错误
   // console.log(error); // for debug
    return error;
  }
);
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 如果响应状态码不是 1 0，认为请求失败
    // if (res.code !== 1 && res.code !== 0 && res.code !== 10000) {
    //  // console.log('请求失败: ' + res.message);
    //   return Promise.reject(new Error(res.message || 'Error'));
    // } else {
    //   return res;
    // }
    return res;
  },
  (error) => {
    // 处理响应错误
   // console.log("err " + error); // for debug
    return error;
  }
);

// 封装请求方法
const request = {
  get(url, params) {
    return service.get(url, { params });
  },
  post(url, data) {
    return service.post(url, data);
  },
  put(url, data) {
    return service.put(url, data);
  },
  delete(url, params) {
    return service.delete(url, { params });
  },
};

export default request;
